var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-vuetify":""}},[_c('v-app',[_c('topup-balance',{key:_vm.formKey,on:{"hideDialog":_vm.redrawForm}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }